import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { LocationEnum } from "./Location.schema"

const disabled = { disabled: true }

const adhRoleConf = {
  [`${LocationEnum.ADDRESS}.${LocationEnum.LINE_1}`]: disabled,
  [`${LocationEnum.ADDRESS}.${LocationEnum.LINE_2}`]: disabled,
  [`${LocationEnum.ADDRESS}.${LocationEnum.POSTAL_CODE}`]: disabled,
  [`${LocationEnum.ADDRESS}.${LocationEnum.CITY}`]: disabled,
  [LocationEnum.LOCATION]: disabled,
  [LocationEnum.FRONT_PARKING]: disabled,
}

export const formRoleConf: RoleStrategy<
  Partial<Record<string, { disabled?: boolean }>>
> = {
  [ROLES.ADMIN]: {},
  [ROLES.ADHERENT_HOLDER]: adhRoleConf,
  [ROLES.ADHERENT_TEAM]: adhRoleConf,
}
